// Projects.jsx
import React from 'react';
import { motion } from 'framer-motion';

// Example images (replace these with actual images from Unsplash or your uploads)
import Project1Image from '../assets/Project1Image.jpg';
import Project2Image from '../assets/Project2Image.png';
import Project3Image from '../assets/Project3Image.jpg';
import Project4Image from '../assets/Project4Image.png';


const projects = [
  {
    title: 'Customer Management Cloud Native App',
    description: `
      Deployed a RESTful CRUD customer management web application on AWS using Go and Postgres.
      Engineered a Terraform template utilizing VPC, Subnets, EC2, S3, and more.
    `,
    image: Project1Image,
    link: '#',
  },
  {
    title: 'ChatGPT Clone with Multi-LLMs',
    description: `
      Championed a ChatGPT Clone using React.js and Material UI, integrating 5+ LLMs.
      Streamlined responses from LLMs using Node.js, Express.js, and MongoDB, reducing query time by 50%.
    `,
    image: Project2Image,
    link: '#',
  },
  {
    title: 'CineGenie — Movie Ticket Booking App',
    description: `
      Developed an AI-powered ticketing app using Node.js, React, and MongoDB.
      Integrated AWS S3 for efficient media transfer, reducing load times by 50%.
    `,
    image: Project3Image,
    link: '#',
  },
  {
    title: 'Cloud Cafeteria — Digital Solution for Students',
    description: `
      Launched a React-based digital cafeteria platform, reducing queue times by 90%.
      Optimized backend and database performance by 40% using Python and Flask.
    `,
    image: Project4Image,
    link: '#',
  },
];

const Projects = () => {
  return (
    <motion.div
      className="projects-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.5 }}
    >
      <h2 className="projects-title">Projects</h2>
      <div className="projects-container">
        {projects.map((project, index) => (
          <motion.div
            key={index}
            className="project-card"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            {/* Project Image */}
            <div className="project-image-container">
              <img
                src={project.image}
                alt={project.title}
                className="project-image"
                loading="lazy"
              />
            </div>
            {/* Project Content */}
            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
            </div>
            {/* Project Link */}
            <div className="project-link-container">
              <a href={project.link} className="project-link">
                View Project &rarr;
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Projects;
